module.exports = __webpack_public_path__ + "static/img/fiber.8860792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fiber.jpg
// module id = xKzv
// module chunks = 1